export default "__VITE_ASSET__BC7NbYtn__"